export enum ApprovedParticipantAction {
  LINK = 'link',
  UNLINK = 'unlink',
}
